"use client";

import Link from "next/link";
import Image from "next/image";
import { useRouter } from "next/navigation";

import { useDispatch, useSelector } from "react-redux";
import { useTranslations } from "next-intl";

import {getFromLocale, getFromSession, removeFromSession, replaceDomain, setToSession} from "@/utils";

import { setTemplateId } from "@/store";

export const ThemeCard = ({
  id,
  categories,
  description,
  image,
  name,
  demo_url,
  onClick,
  pages,
  installs_count,
  site_name
}) => {
  const dispatch = useDispatch();
  const navigate=useRouter()
  const package_id = useSelector((state) => state.template.package_id);


  const handleConfirmTheme = async () => {
      const templateId = getFromSession("template_id");
      if(templateId) {
          removeFromSession("template_id");
          removeFromSession("template_name");
          removeFromSession("package_id");
          removeFromSession("package_name");
          removeFromSession("package_type");
          removeFromSession("amount");

      }
      dispatch(setTemplateId(id));
      const token= getFromLocale()
      setToSession({ value: id, key: 'template_id' })
      setToSession({ value: name, key: 'template_name' })

      if(package_id && token){
        navigate.push(`?step=3&template_id=${id}&package_id=${package_id}&path=confirmation`);
      }
      else{
        navigate.push(`?step=2&template_id=${id}`);
      }
  };

  const handleCardClick = () => {
    const data = {
      id,
      categories,
      description,
      image,
      name,
      demo_url,
      pages,
      installs_count
    };
    onClick(data);
  };
  const t = useTranslations()
  return (
    <div
      className="blog-post relative py-2 md:min-w-[414px] px-2 pt-2 rounded-[7px] transform hover:shadow-lg hover:shadow-[#14AEED]/10 hover:border-[#149dda]/20 hover:bg-[#14AEED]/10 transition duration-200 ease-in border-[1px] border-solid border-slate-100 cursor-pointer">
      <div className="h-[220px]">
        <Image
          className="w-full h-full object-cover rounded-[7px] border border-solid border-slate-200"
          src={`${image}`}
          width={296}
          height={220}
          onClick={handleCardClick}
          alt="Template"
        />
      </div>
      <h1 className="text-center py-1 font-semibold text-lg">{name}</h1>
      <div className="text-center flex justify-evenly">
        <Link
          href={replaceDomain(demo_url, 'site.az', site_name) ?? "/"}
          target="_blank"
          className="m-2 inline-flex items-center px-8 py-2 border border-transparent md:text-lg xmd:text-base text-sm font-medium rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 hover:text-blue-700 transition-all duration-200"
        >
          {t("demo")}
        </Link>
        <button
          onClick={handleCardClick}
          className="m-2 inline-flex items-center px-8 py-2 border border-transparent md:text-lg xmd:text-base text-sm font-medium rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 hover:text-blue-700 transition-all duration-200"
        >
          {t("view")}
        </button>
        <button
          onClick={handleConfirmTheme}
          className="m-2 inline-flex items-center px-8 py-2 border border-transparent md:text-lg xmd:text-base text-sm font-medium rounded-md text-white bg-mainLightPurple hover:bg-mainLightPurpleHover transition-all duration-200"
        >
          {t("select")}
        </button>
      </div>
    </div>
  );
};
